module.exports = __webpack_public_path__ + "files/46661d6d65debc63884004fed6e37e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-italic.svg
// module id = 1586
// module chunks = 60